import { SecretFormatter } from "namirasoft-account-react";
import { EncodingOperation } from "namirasoft-core";
import { UserFullRow } from "namirasoft-password";
import { BaseColumnFormatter, EncryptionOperation, TableColumnInfo, TableRowInfo } from "namirasoft-site-react";
import { PasswordRouterProps } from "../PasswordRouterProps";
import { Storage } from "../Storage";

export class PasswordFormatter<RowType = any> extends BaseColumnFormatter
{
    private secret_formatter: SecretFormatter;

    constructor(public props: PasswordRouterProps & { user: UserFullRow }, public isSensitive: (col: TableColumnInfo, row: TableRowInfo<RowType>) => boolean, width: string = "240px")
    {
        super();
        this.width = width;
        this.secret_formatter = new SecretFormatter(props.servers.secret, isSensitive, true, width);
        this.secret_formatter.decryptor = async (value) =>
        {
            let master_key = await Storage.getMasterKey(props.user.id);
            let encoded_value = await EncryptionOperation.AES256GCMDecrypt(master_key, value) as string;
            let final_value = EncodingOperation.Base64Decode(encoded_value);

            return final_value;
        }
    }

    override format(value: any, column: TableColumnInfo, row: TableRowInfo<any>, printable: boolean)
    {
        return this.secret_formatter.format(value, column, row, printable);
    }
}